import { NavLink } from "react-router-dom";

const ProfileMenu = () => {
  return (
    <ul className="profileMenu pillMenu">
      <li>
        <NavLink
          to="/profile"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Account Settings
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/change-password"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Change Password
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/setup-calendar"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Setup Calendar
        </NavLink>
      </li>

      <li>
        <NavLink
          to="/professional-settings"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Professional Setting
        </NavLink>
      </li>
    </ul>
  );
};

export default ProfileMenu;
